// src/config/artistTypes.js

/**
 * ARTIST_TYPES
 * -------------
 * key  = arvon, joka menee tietokantaan (bands.artist_type)
 * label = ihmisen luettava teksti
 * defaultDepositPct    = varausmaksun % (asiakkaalta laskutettava ennakko)
 * defaultCommissionPct = Buukkerin välityspalkkio %
 *
 * TÄRKEÄÄ:
 * - Lisää uusi tyyppi vain tänne → kaikki paikat, jotka käyttävät
 *   tätä konffia, tukevat sitä automaattisesti.
 */
export const ARTIST_TYPES = {
  bilebandi: {
    label: "Bilebändi",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  trubaduuri: {
    label: "Trubaduuri",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  taikuri: {
    label: "Taikuri",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  duo: {
    label: "Duo",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  sooloartisti: {
    label: "Sooloartisti",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  valokuvaaja: {
    label: "Valokuvaaja",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  dj: {
    label: "DJ",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  band: {
    label: "Bändi (oma musiikki)",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  standup: {
    label: "Standup-koomikko",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
  juontaja: {
    label: "Juontaja",
    defaultDepositPct: 12,
    defaultCommissionPct: 12,
  },
};

/**
 * Lista valintakomponentteja varten:
 * [{ value: "bilebandi", label: "Bilebändi / coverbändi" }, ...]
 */
export const ARTIST_TYPE_OPTIONS = Object.entries(ARTIST_TYPES).map(
  ([value, cfg]) => ({
    value,
    label: cfg.label,
  })
);
